import { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { isMobile } from 'react-device-detect';


import { createColorStyles, showModal } from '../common/utilities';
import { JobItem } from './JobItem';
import { AVAILABLE_JOB_POSITION } from '../common/constants';

export class Jobs extends Component {
    constructor(props) {
        super(props);

        this.jobOnClick = this.jobOnClick.bind(this);
    }

    componentDidMount() {
        const {
            setTracedJobs,
            getTracedJobs,
            isMixpanel,
            jobs,
        } = this.props;

        const parent = this;

        //on job mouseover
        $(document).on('mouseover', '.job', function(e) {
            const el = this;
            if (!el.classList.contains('is-hover')) {
                el.classList.add('is-hover');
            }
        });

        $(document).on('mouseenter', '.job .front', function(e) {
            const jobTitle = $(this).find('.title').text() || 'N/A';

            if (isMixpanel) {
                window.mixpanel.track(`Job Hover`, {
                    'Job Title': jobTitle,
                });
            }
        });

        $(document).on('mouseenter', '.direction.growth', function(e) {
            const el = $(this);

            const jobTitle = el.closest('.job').find('.title').text() || 'N/A';

            if (isMixpanel) {
                window.mixpanel.track(`Job Hover`, {
                    'Job Title': jobTitle,
                    'Direction': 'Up'
                });
            }
        });

        $(document).on('mouseenter', '.direction.down', function(e) {
            const el = $(this);

            const jobTitle = el.closest('.job').find('.title').text() || 'N/A';

            if (isMixpanel) {
                window.mixpanel.track(`Job Hover`, {
                    'Job Title': jobTitle,
                    'Direction': 'Down'
                });
            }
        });

        $(document).on('click', '.modal-list li a', function(e) {
            const el = $(this);

            const jobTitle = el.closest('.modal').find('.modal-header .modal-job-name').text() || 'N/A';

            if (isMixpanel) {
                window.mixpanel.track('Content Link Click', {
                    'Content Url': el.attr('href'),
                    'Job Title': jobTitle,
                });
            }
        });

        $(document).on('click', '.job .js-modal', function(e) {
            const el = $(this);

            const jobTitle = el.closest('.description-inner').find('.description-title').text() || 'N/A';

            if (isMixpanel) {
                window.mixpanel.track('"Find out More" Click', {
                    'Job Title': jobTitle,
                });
            }
        });

        //on job mouseout
        $(document).on('mouseout', '.job', function() {
            const el = this;
            el.classList.remove('is-hover');
        });

        //on job click
        $(document).on('click', '.job', function(event) {
            let el = this;

            parent.jobOnClick(el, event);
        });

        // Activate jobs if page loads with already preselected jobs
        if (getTracedJobs()) {
            const isAllPreselectedJobsAvailable = getTracedJobs().every(jobIdFromPath => jobs.some(job => job.id === jobIdFromPath));

            if (!isAllPreselectedJobsAvailable) {
                const modal = document.querySelector('#need-rebuild-path');

                showModal(modal);

                setTracedJobs([]);
            } else {
                setTimeout(() => {
                    if (getTracedJobs().length === 1) {
                        let jobItem = document.querySelector(`.job:not(.fake)[data-id="${getTracedJobs()[0]}"]`);

                        if (jobItem) {
                            if (jobItem.querySelector('.direction.growth')) {
                                jobItem.querySelector('.direction.growth').click();
                            } else {
                                jobItem.querySelector('.direction.middle').click();
                            }
                        }
                    } else {
                        getTracedJobs().forEach((id, index) => {
                            let jobItem = document.querySelector(`.job:not(.fake)[data-id="${id}"] .direction.growth`)
                                ? document.querySelector(`.job:not(.fake)[data-id="${id}"] .direction.growth`)
                                : ( document.querySelector(`.job:not(.fake)[data-id="${id}"] .direction.down`)
                                        ? document.querySelector(`.job:not(.fake)[data-id="${id}"] .direction.down`)
                                        : document.querySelector(`.job:not(.fake)[data-id="${id}"] .direction.middle`)
                                );

                            if (jobItem) {
                                setTimeout(() => jobItem.click(), 500 * index);
                            }
                        })
                    }
                }, 500);
            }
        }
    }

    jobOnClick(target, event) {
        const {
            reset,

            isTraced,

            getTracedJobs,
            setTracedJobs,

            isCurated,

            getCuratedJobs,
            showCuratedJobs,
            setSearch,

            isMixpanel,
            mapNode
        } = this.props;

        const parent = this;

        const id = parseInt(target.dataset.id);

        const el = target.classList.contains('fake')
            ? document.querySelector('.job:not(.fake)[data-id="' + id + '"]')
            : target

        let direction = event.target.closest('.direction')
            ? event.target.closest('.direction').dataset.direction
            : false;

        if ((isMobile || (window.innerWidth < 768 && process.env.NODE_ENV !== 'production')) && !el.classList.contains('is-traced')) {
            direction = 'middle';
        }

        // bubble close button click
        if(event.target.classList.contains('description-close')) {
            parent.hideSpecificDescription(target);
            target.classList.remove('is-hover');

            if (getTracedJobs().length === 1) {
                reset();
            }

            if (isCurated()) {
                reset();
                setTracedJobs([]);
                showCuratedJobs();
            }

            return;
        }

        if ($(event.target).closest('.front').length) {
            const jobTitle = $(el).closest('.job').find('.title').text() || 'N/A';

            if (isMixpanel) {
                window.mixpanel.track(`Job Click`, {
                    'Job Title': jobTitle,
                    'Direction': direction === 'middle' ? 'Middle' : (direction === 'growth-lateral' ? 'Up' : 'Down'),
                });

                window.mixpanel.track(`"${jobTitle}" Click`, {
                    'Direction': direction === 'middle' ? 'Middle' : (direction === 'growth-lateral' ? 'Up' : 'Down'),
                });
            }
        }

        setSearch('');

        if (isTraced() && !isCurated()) {
            if (direction === 'middle') {
                const oldTracedJobs = getTracedJobs();

                if (getTracedJobs().indexOf(id) !== -1) {
                    let slicedJobs = getTracedJobs()
                        .slice(0, getTracedJobs().indexOf(id) + 1);

                    setTracedJobs(slicedJobs);

                } else {
                    setTracedJobs([...getTracedJobs(), id])
                }

                // if a job is only one and already selected
                if (getTracedJobs().length === 1 && el.classList.contains('is-traced') && oldTracedJobs.length === 1) {
                    reset();

                    return;
                } else if (getTracedJobs().length === 1 && !el.classList.contains('is-traced')) {
                    // if a job is only one and has not been selected yet
                    parent.showTrace(getTracedJobs());

                    mapNode().classList.add('is-active');
                    el.setAttribute('data-direction', 'growth-lateral');

                    parent.showPath(el, 'growth-lateral');
                }

                // make step back
                if (oldTracedJobs.indexOf(id) !== oldTracedJobs.length - 1) {
                    reset(false);

                    parent.showTrace(getTracedJobs());

                    mapNode().classList.add('is-active');
                    el.setAttribute('data-direction', 'growth-lateral');

                    parent.showPath(el, 'growth-lateral');
                }

                let jobNode = document.querySelector('.job.fake[data-id="' + id + '"]');

                if (jobNode) {
                    if (jobNode.classList.contains('show-description')) {
                        parent.hideSpecificDescription(jobNode);
                    } else {
                        parent.showSpecificDescription(jobNode);
                    }
                }
            } else if (direction === 'growth-lateral' || direction === 'down') {
                if (getTracedJobs().indexOf(id) !== -1) {
                    setTracedJobs(getTracedJobs()
                        .reverse()
                        .splice(getTracedJobs().indexOf(id))
                        .reverse()
                    )

                } else {
                    setTracedJobs([...getTracedJobs(), id])
                }

                reset(false);

                parent.showTrace(getTracedJobs());
                parent.activateJob(el, direction);
                parent.showPath(el, direction);
            }
        } else if (isCurated()) { //curated paths
            if (!el.classList.contains('is-active') && el.dataset.curated) {
                let trace = getCuratedJobs().filter((obj) => obj.id === parseInt(el.dataset.curated));

                if (trace) {
                    trace = trace[0].jobs
                }

                reset(true, false);

                parent.activateJob(el, direction);

                if (trace.length) {
                    setTracedJobs([...trace].reverse());

                    parent.showTrace(trace);
                }
            }
        }
    }

    hideAllDescriptions() {
        [].forEach.call(document.querySelectorAll('.job'), function(job) {
            job.classList.remove('show-description');
        });
    }

    showSpecificDescription(el) {
        if(el && !el.classList.contains('show-description')) {
           this.hideAllDescriptions();

           el.classList.add('show-description');
        }
    }

    hideSpecificDescription(el) {
        if(el && el.classList.contains('show-description')) {
            el.classList.remove('show-description');
        }
    }

    showPath(el, direction) {
        const { jobs } = this.props;

        const id = parseInt(el.dataset.id);
        const job_object = jobs.filter((job) => job.id === id);
        let path = null;
        let drawLineTo = false;

        this.createFakeElement(el);

        if (job_object.length) {
            const currentJobLevelIndex = parseInt(el.dataset.levelIndex);

            if (direction === 'growth-lateral') {
                path = job_object[0].job_growth_opportunities;
                drawLineTo = true;
            } else if (direction === 'middle') {
                path = [id];
                drawLineTo = true;
            } else { // down
                path = jobs
                    .filter(job => job.job_growth_opportunities && job.job_growth_opportunities.includes(id))
                    .filter(job => {
                        const jobElement = document.querySelector('.job:not(.fake)[data-id="' + job.id + '"]');

                        return jobElement && (currentJobLevelIndex <= parseInt(jobElement.dataset.levelIndex))
                    })
                    .map(job => job.id);
            }

            if (path) {
                path.forEach(pathId => {
                    if (document.querySelector('.job[data-id="' + pathId + '"]')) {
                        const fake = document.querySelector('.job.fake[data-id="' + pathId + '"]');

                        if (fake) {
                            if (fake.classList && !fake.classList.contains('is-traced')) {
                                fake.remove();
                            }
                        }

                        let child = document.querySelector('.job:not(.fake)[data-id="' + pathId + '"]');

                        if (!child.classList.contains('is-traced')) {
                            child.classList.add('is-selected');

                            //create a clone of the path job and put it over the lines
                            this.createFakeElement(child);

                            //draw line form parent to child
                            if(drawLineTo) {
                                this.drawLine(el, child);
                            } else {
                                this.drawLine(child, el);
                            }
                        }
                    }
                });
            }
        }
    }

    drawLine(from, to, color = 'white', animate = true) {
        const { mapNode } = this.props;

        to = to.querySelector('.dot');
        from = from.querySelector('.dot');

        const map_coordinates = mapNode().getBoundingClientRect();
        const from_coordinates = from.getBoundingClientRect();
        const to_coordinates = to.getBoundingClientRect();
        const mapLeftOffset = mapNode().scrollLeft;
        const mapTopOffset = mapNode().scrollTop;

        const x_from = (from_coordinates.x + from_coordinates.width / 2) - map_coordinates.x + mapLeftOffset;
        const y_from = (from_coordinates.y + from_coordinates.height / 2) - map_coordinates.y + mapTopOffset;
        const x_to = (to_coordinates.x + to_coordinates.width / 2) - map_coordinates.x + mapLeftOffset;
        const y_to = (to_coordinates.y + to_coordinates.height / 2) - map_coordinates.y + mapTopOffset;

        const line_length = Math.sqrt((x_from - x_to) * (x_from - x_to) + (y_from - y_to) * (y_from - y_to));
        const line_angle = Math.atan2(y_to - y_from, x_to - x_from) * 180 / Math.PI;

        const line = document.createElement('a');
        line.classList.add('path-line', color);

        line.style.cssText = `display: block; top: ${y_from}px; left: ${x_from}px; transform: rotate(${line_angle}deg);`;

        if (!animate) {
            line.style.cssText = line.style.cssText + `width: ${line_length}px`;
        }

        mapNode().appendChild(line);

        if (animate) {
            $(line).animate({ width: line_length }, 750);
        }
    };

    removeClones(el) {
        document.querySelector('.job.fake[data-id="' + el.dataset.id + '"]')
            ? document.querySelector('.job.fake[data-id="' + el.dataset.id + '"]').remove()
            : null;
    }

    createFakeElement(el) {
        const { mapNode } = this.props;

        this.removeClones(el);

        const el_coordinates = el.getBoundingClientRect();
        const map_coordinates = mapNode().getBoundingClientRect();
        const mapLeftOffset = mapNode().scrollLeft;
        const mapTopOffset = mapNode().scrollTop;

        const fakeEl = el.cloneNode(true);

        let leftPos = el_coordinates.x - map_coordinates.x + mapLeftOffset;
        let topPost = el_coordinates.y - map_coordinates.y + mapTopOffset;

        fakeEl.classList.add('fake');
        fakeEl.classList.remove('hidden');

        fakeEl.style.cssText = fakeEl.style.cssText + `left: ${leftPos + 'px'}; top: ${topPost + 'px'}; width: ${el_coordinates.width + 'px'}; opacity: 1;`;

        el.classList.add('hidden');
        mapNode().appendChild(fakeEl);
    }

    activateJob(el, direction) {
        const { mapNode } = this.props;

        el.classList.add('is-active');
        mapNode().classList.add('is-active');
        el.setAttribute('data-direction', direction);
    }

    showTrace(arr) {
        arr.forEach((id, index) => {
            const job = document.querySelector('.job:not(.fake)[data-id="' + id + '"]');
            const nextJob = document.querySelector('.job:not(.fake)[data-id="' + arr[index + 1] + '"]');

            if (job) {
                job.classList.add('is-traced');

                this.createFakeElement(job);

                if (nextJob) {
                    this.drawLine(job, nextJob, 'black', false);
                }
            }
        });
    }

    /**
     * Prepare position of job
     *
     * For example: job position before [2, 2, 4, 5, 6, 2, 4, 9] after [2, 1, 4, 5, 6, 3, 7, 9]
     * @param desiredPosition
     * @param availablePositions
     * @returns {number|*|number|number}
     */
    getJobPosition(desiredPosition, availablePositions = []) {
        let position = desiredPosition;

        if (availablePositions.length) {
            if (position > Math.max.apply(null, availablePositions) || position < Math.min.apply(null, availablePositions)) {
                position = Math.min.apply(null, availablePositions);
            }

            if (availablePositions.includes(position)) {
                availablePositions.splice(availablePositions.indexOf(position), 1);

                return position;
            }

            return this.getJobPosition(availablePositions[0], availablePositions);
        }

        return 1; // return default position
    }


    render() {
        const {
            levels,
            categories,
            jobs,
            isShowCollegeDegree,
            isShowSalary,
        } = this.props;

        return (
            levels.map((level, levelIndex) => (
                <div
                    key={levelIndex}
                    className={`row level-${levelIndex + 1}`}
                >
                    <div className="level">
                        <h2 className="level-name"><span>{level.name}</span></h2>
                    </div>

                    {
                        categories.map((cat, catIndex) => {
                            let availablePositions = [...AVAILABLE_JOB_POSITION];

                            return <div
                                key={catIndex}
                                className="jobs"
                                style={createColorStyles(cat)}
                            >
                                {
                                    jobs
                                        .filter(job => job.job_category.id === cat.id && job.job_level.id === level.id)
                                        .sort((jobFirst, jobSecond) => jobFirst.icon_position - jobSecond.icon_position)
                                        .map((job) => {
                                            const position = this.getJobPosition(job.icon_position, availablePositions);

                                            return <JobItem
                                                key={job.id}
                                                job={job}
                                                position={position}
                                                levelIndex={levelIndex}
                                                cat={cat}
                                                catIndex={catIndex}
                                                categories={categories}
                                                jobs={jobs}
                                                levels={levels}
                                                isShowCollegeDegree={isShowCollegeDegree}
                                                isShowSalary={isShowSalary}
                                             />
                                        })
                                }
                            </div>
                        })
                    }

                </div>
            ))
        );
    }
}

Jobs.propTypes = {
    levels: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    jobs: PropTypes.array.isRequired,
    isShowCollegeDegree: PropTypes.bool.isRequired,

    reset: PropTypes.func.isRequired,

    isTraced: PropTypes.func.isRequired,
    isCurated: PropTypes.func.isRequired,

    setTracedJobs: PropTypes.func.isRequired,
    getTracedJobs: PropTypes.func.isRequired,

    getCuratedJobs: PropTypes.func.isRequired,
    showCuratedJobs: PropTypes.func.isRequired,

    setSearch: PropTypes.func.isRequired,
    mapNode: PropTypes.func.isRequired,

    isMixpanel: PropTypes.bool.isRequired,
}
